var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "c-communities__tiles u-m-t4@m u-m-t3@s",
        class: _vm.showEmptyMessage === false ? "u-m-t1" : "",
      },
      [
        _c("div", { staticClass: "o-wrapper" }, [
          _c("div", { staticClass: "o-grid o-grid--center" }, [
            _vm.communities.length !== 0
              ? _c(
                  "div",
                  { staticClass: "o-grid__item u-width-10/12 u-width-full@l" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "c-communities__wrapper u-m-b4",
                        attrs: { id: "communities" },
                      },
                      _vm._l(_vm.communities, function (item) {
                        return _c(
                          "div",
                          {
                            class: [
                              "c-communities__tile",
                              item.accredited ? "accredited" : "",
                            ],
                          },
                          [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href:
                                    "/u/" +
                                    _vm.$root.profile.username +
                                    "/" +
                                    item.url +
                                    "/posts",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "c-communities__profile" },
                                  [
                                    _c("img", {
                                      staticClass:
                                        "c-communities__img u-m-r1@s",
                                      attrs: {
                                        srcset:
                                          _vm.$simpleStore.transformImageWithCloudfront(
                                            120,
                                            120,
                                            item.image,
                                            _vm.$root,
                                            "srcset"
                                          ),
                                        src: _vm.$simpleStore.transformImageWithCloudfront(
                                          120,
                                          120,
                                          item.image,
                                          _vm.$root
                                        ),
                                        alt: item.name,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "c-communities__name" },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(item.name) +
                                            "\n                                        "
                                        ),
                                        item.total_user_posts > 1
                                          ? _c("span", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    item.total_user_posts
                                                  ) +
                                                  " articles)"
                                              ),
                                            ])
                                          : item.total_user_posts === 1
                                          ? _c("span", [
                                              _vm._v(
                                                "(" +
                                                  _vm._s(
                                                    item.total_user_posts
                                                  ) +
                                                  " article)"
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.$root.user.username === _vm.$root.profile.username
                      ? _c("div", { staticClass: "c-communities__feed" }, [
                          _c(
                            "a",
                            { staticClass: "button", attrs: { href: "/" } },
                            [_vm._v("Go to your feed")]
                          ),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showEmptyMessage
              ? _c(
                  "div",
                  {
                    directives: [{ name: "else", rawName: "v-else" }],
                    staticClass: "o-grid__item u-width-8/12 u-width-full@l",
                  },
                  [
                    _vm.$root.isOwnAccount
                      ? _c("div", { staticClass: "c-empty-state" }, [
                          _c("h4", [
                            _vm._v(
                              "\n                            Become a member of your favorite communities\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n                            You are not yet a member of any communities, to\n                            get started simply click on the Find a Community\n                            icon below.\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              staticClass:
                                "c-empty-state__community_select u-m-t3",
                              attrs: { href: "/communities" },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "c-communities-select__tile" },
                                [
                                  _c("img", {
                                    staticClass: "c-communities-select__img",
                                    attrs: {
                                      src: _vm.$cdn(
                                        "/img/icons/icon-communities-squared--contained.svg"
                                      ),
                                      width: "99",
                                      height: "99",
                                      alt: "find communities",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm._m(0),
                                ]
                              ),
                            ]
                          ),
                        ])
                      : _c("div", { staticClass: "c-empty-state" }, [
                          _c("h4", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$root.profile.first_name) +
                                " is not yet a\n                            member of any communities\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "As soon as they do they will be listed here."
                            ),
                          ]),
                        ]),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "c-communities-select__name" }, [
      _c("p", [_vm._v("Find a Community")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }